import { abortErrorWithoutStackContextRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/abortErrorWithoutStackContext';
import { googleAnalyticsDashboardErrorRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/googleAnalyticsDashboardError';
import { nextRouteCancellationRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/nextRouteCancellation';
import { nonErrorObjectNotFoundMatchingIdUnhandledRejectionRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/nonErrorObjectNotFoundMatchingIdUnhandledRejection';
import { nonErrorOutOfMemoryUnhandledRejectionRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/nonErrorOutOfMemoryUnhandledRejection';
import { nonErrorTauriEventListenAclUnhandledRejectionRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/nonErrorTauriEventListenAclUnhandledRejection';
import { nonErrorTauriScraperEventEmitUnhandledRejectionRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/nonErrorTauriScraperEventEmitUnhandledRejection';
import { syntaxErrorUnexpectedEndOfInjectedInitScriptRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/syntaxErrorUnexpectedEndOfInjectedInitScript';
import { thirdPartyABSmartlyAbortErrorRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/thirdPartyABSmartlyAbortError';
import { thirdPartyMaskedUrlReferenceErrorRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/thirdPartyMaskedUrlReferenceError';
import { thirdPartyMsHeaderAbortErrorRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/thirdPartyMsHeaderAbortError';
import { thirdPartyUwtUriErrorRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/thirdPartyUwtUriError';
import { ClientSentryIgnoreRule } from '@/shared/utils/sentry/clientIgnoreRules/types';

export const CLIENT_SENTRY_IGNORE_RULES: readonly ClientSentryIgnoreRule[] = [
  abortErrorWithoutStackContextRule,
  googleAnalyticsDashboardErrorRule,
  nextRouteCancellationRule,
  nonErrorObjectNotFoundMatchingIdUnhandledRejectionRule,
  nonErrorOutOfMemoryUnhandledRejectionRule,
  nonErrorTauriEventListenAclUnhandledRejectionRule,
  nonErrorTauriScraperEventEmitUnhandledRejectionRule,
  syntaxErrorUnexpectedEndOfInjectedInitScriptRule,
  thirdPartyABSmartlyAbortErrorRule,
  thirdPartyMaskedUrlReferenceErrorRule,
  thirdPartyMsHeaderAbortErrorRule,
  thirdPartyUwtUriErrorRule,
];
